export const environment = {
    production: false,
    apiUrl: 'https://broken-night-7120.getsandbox.com',
    apiUrlBuffer: '',
    token: '',
  
    client: '',
    redirectUri: 'http://localhost:4200',
    authority: '',
  };
  